import React from "react";
import "./InfiniteMarquee.scss";

const InfiniteMarquee = () => {
  return (
    <div className="marquee-wrapper">

      {/* FORWARD */}
      <div className="marquee forward">
        <div className="marquee-track">
          <span>Full-Service Design & Technical Delivery. Architecture. Interiors. 3D & BIM.</span>
          <span>Full-Service Design & Technical Delivery. Architecture. Interiors. 3D & BIM.</span>
          <span>Full-Service Design & Technical Delivery. Architecture. Interiors. 3D & BIM.</span>
        </div>
      </div>

      {/* BACKWARD */}
      <div className="marquee backward">
        <div className="marquee-track">
          <span>Residential. Commercial. Office. Retail. Renovation. New Build.</span>
          <span>Residential. Commercial. Office. Retail. Renovation. New Build.</span>
          <span>Residential. Commercial. Office. Retail. Renovation. New Build.</span>
        </div>
      </div>

    </div>
  );
};

export default InfiniteMarquee;
